import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Alert, Checkbox, createTheme, FormControlLabel, FormGroup, Snackbar, Stack } from '@mui/material';
import Button from '@mui/material/Button';
import OtpInput from 'react-otp-input';
import { useEffect, useState } from 'react';
import { GenerateOTP, GetOTP } from '../../../api';
import useStyles from '../../../css/styles';

// Update log
// FB  6192   02/06/2023  DK  Added page to verify the Patient through phone or email during registration

export default function VerifyUser(props: any) {
    const styles = useStyles();
    const [sendEmail, setSendEmail] = useState(0);
    const [sendText, setSendText] = useState(0);
    const validOTPlength = 4;
    const [OTP, setOTP] = useState("");
    const [isCodesent, setIsCodesent] = useState<Boolean>(false);
    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(2);
    const [isOTPErrored, setIsOTPErrored] = useState(false);
    const [isTimeOut, setIsTimeOut] = useState(false);
    const [isCodeResent, setIsCodeResent] = useState(false);
    const [snackbarConfig, setSnackbarConfig] = React.useState({ open: false, message: "", severity: 'success' });
    const theme = createTheme({
        palette: {
            primary: {
                main: "#18a2b8",
            },
        },
    });
    const handleOTPInput = (value: any) => {
        setOTP(value);
    }

    const handleSendcode = async () => {
        await GenerateOTP(props.patient, sendEmail, sendText)
            .then((data) => {
                setIsCodesent(true);
                setMinutes(2);
                setSeconds(0);
                setSnackbarConfig({ open: true, message: "Code sent successfully!", severity: 'success' });
            })
            .catch((error) => error);
    }

    const handleReSendCode = async () => {
        await GenerateOTP(props.patient, sendEmail, sendText)
            .then((data) => {
                setOTP("");
                setIsCodeResent(true);
                setIsOTPErrored(false);
                setIsTimeOut(false);
                setMinutes(2);
                setSnackbarConfig({ open: true, message: "Code re-sent successfully!", severity: 'success' });
            })
            .catch((error) => error);
    }

    const handleEmailCheckbox = async (e: any) => {
        if (e.target.checked) {
            setSendEmail(1);
        }
        else {
            setSendEmail(0);
        }
    }

    const handlePhoneCheckbox = async (e: any) => {
        if (e.target.checked) {
            setSendText(1);
        }
        else {
            setSendText(0);
        }
    }

    const handleVerifyCode = async () => {
        await GetOTP(props.patient.EMRID)
            .then((data) => {
                if (data == OTP) {
                    setSnackbarConfig({ open: true, message: "Code verified successfully!", severity: 'success' });
                    props.setIsUserVerified(true);
                }
                else {
                    setOTP("");
                    setIsOTPErrored(true);
                }
            })
            .catch((error) => error);
    }

    function updateTime() {
        if (minutes == 0 && seconds == 0) {
            setIsTimeOut(true);
            setOTP("");
            setIsOTPErrored(false);
        }
        else {
            if (seconds == 0) {
                setMinutes(minutes => minutes - 1);
                setSeconds(59);
            } else {
                setSeconds(seconds => seconds - 1);
            }
        }
    }

    function formatPhone(phonenumber: string) {
        if (phonenumber != "" && phonenumber != null && phonenumber != undefined) {
            phonenumber = phonenumber.replace(/[^0-9]/g, "");
            phonenumber = "(" + phonenumber.slice(0, 3) + ") " + phonenumber.slice(3, 6) + "-" + phonenumber.slice(6, 10);
            phonenumber = phonenumber.replace(/^(.{0})[^-]+/, "$1******")
        }
        else {
            phonenumber = "";
        }
        return phonenumber;
    }

    function formatEmailID(email: string) {
        if (email != "" && email != null && email != undefined) {
            email = email.replace(/^(.{1})[^@]+/, "$1******")
        }
        else {
            email = "";
        }
        return email;
    }

    useEffect(() => {
        const token = setTimeout(updateTime, 1000)

        return function cleanUp() {
            clearTimeout(token);
        }
    }, [minutes, seconds])

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        setSnackbarConfig({ "open": false, "message": "", severity: 'success' });
    };

    return (
        <React.Fragment>
            <div style={{ display: isCodesent ? "none" : "block" }}>
                <Typography variant="h6" gutterBottom>
                    <strong>Verification code</strong>
                </Typography>
                <Typography>
                    To confirm your identity, We will send a four digit code to the below selected option(s).
                </Typography>
                <br />
                <Typography>
                    By tapping Send code, You are confirming that you are authorized to use the number/email and agree to receive text/email for verification. Carrier fees may apply.
                </Typography>
                <br />
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{ display: formatEmailID(props.patient.PatientEmail).length > 0 ? "flex" : "none" }}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox onChange={handleEmailCheckbox}
                                style={{ color: "#18a2b8" }} />} label={formatEmailID(props.patient.PatientEmail)} />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} style={{ display: formatPhone(props.patient.PatientCellPhone).length > 0 ? "flex" : "none" }}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox onChange={handlePhoneCheckbox}
                                style={{ color: "#18a2b8" }} />} label={formatPhone(props.patient.PatientCellPhone)} />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={6} sm={3} md={2}>
                        <Button
                            variant="contained"
                            className={styles.navigationButton}
                            onClick={handleSendcode}
                            disabled={sendEmail > 0 || sendText > 0 ? false : true}
                        >
                            Send Code
                        </Button>
                    </Grid>
                </Grid>
            </div>
            <div style={{ display: isCodesent ? "block" : "none" }}>
                <Typography variant="h6" gutterBottom>
                    <strong>Confirm your identity</strong>
                </Typography>
                <Typography>
                    Please enter the code you received.
                </Typography>
                <br />
                <Grid container spacing={3} className={styles.pb10}>
                    <Grid item xs={12} style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                        <Typography style={{ display: !isTimeOut ? "flex" : "none" }}>
                            {minutes + "m " + seconds + "s left"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <OtpInput
                            value={OTP}
                            onChange={handleOTPInput}
                            numInputs={validOTPlength}
                            separator={<span>-</span>}
                            isInputNum={true}
                            inputStyle={styles.otp}
                            shouldAutoFocus
                            hasErrored={isOTPErrored}
                            errorStyle={styles.otpError}
                            isDisabled={isTimeOut ? true : false}
                        />
                    </Grid>
                    <Grid item xs={6} sm={3} md={2}>
                        <Button
                            variant="contained"
                            className={OTP.length < validOTPlength ? styles.disabledButton : styles.navigationButton}
                            disabled={(OTP.length < validOTPlength) || props.isUserVerified || isTimeOut ? true : false}
                            onClick={handleVerifyCode}
                            style={{ marginLeft: 5 }}
                        >
                            Verify code
                        </Button>
                    </Grid>
                    <Grid item xs={6} sm={3} md={2}>
                        <Button
                            variant="contained"
                            className={styles.navigationButton}
                            style={{ display: isTimeOut ? "flex" : "none", marginLeft: 5 }}
                            onClick={handleReSendCode}
                        >
                            Resend code
                        </Button>
                    </Grid>
                </Grid>
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={snackbarConfig.open} autoHideDuration={6000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity={snackbarConfig.severity === "success" ? "success" : "error"} sx={{ width: '100%' }}>
                            {snackbarConfig.message}
                        </Alert>
                    </Snackbar>
                </Stack>
            </div>
        </React.Fragment >
    );
}